import React, { useState, useContext, useEffect } from "react";
import Star from "../../../../images/star.svg";
import InvoiceView from "./InvoiceView";
import { deleteBilling, getAllBillingsByID } from "../../../../Utils/localStore";
import ToastContext from "../../../../context/toasterContex";



const PatientBilling = ({ invoice, update, details }) => {
  const { toast } = useContext(ToastContext)
  const [view, setView] = useState(false);
  const [currInvoice, setcurrInvoice] = useState(null)
  const [edit, setEdit] = useState(false);
  const [savedDocs, setSavedDocs] = useState([])
  const [showDeleteDialog, setShowDeleteDialog] = useState(false)


  const getInvoiceData = async () => {
    console.log('got called');
    await getAllBillingsByID(details.localID)
      .then(resp => {
        console.log(resp);
        setSavedDocs(resp)
      })
  }

  useEffect(() => {
    getInvoiceData()
  }, [setSavedDocs, currInvoice])

  const handleView = (data) => {
    console.log({ data });
    setcurrInvoice(data)
    setView(true);
  };
  const handleEdit = (data) => {
    setcurrInvoice(data)
    setEdit(true)
  }

  const handleDocDelete = async () => {
    if (currInvoice) {
      await deleteBilling(currInvoice.localID)
        .then(resp => {
          toast.success('Record deleted successfully', { position: toast.POSITION.TOP_CENTER })
        })
        .catch(err => {
          console.log({ err });
        })
      getInvoiceData()
      setShowDeleteDialog(false)
    } else {
      toast.error('Something seems wrong', { position: toast.POSITION.TOP_CENTER })
    }
  }

  const closeView = () => {
    setView(false);
  };

  const Invoices = [
    {
      id: 1,
      name: "PD/06-0012",
      status: "Paid",
      department: "Pharmacy",
      createdAt: "Created on Monday 17 May, 2023 at 12:00 PM WAT",
    },
    {
      id: 2,
      name: "PD/06-0013",
      status: "Unpaid",
      department: "Radiology",
      createdAt: "Created on Monday 17 May, 2023 at 12:00 PM WAT",
    },
    {
      id: 3,
      name: "PD/06-0045",
      status: "Unpaid",
      department: "Diagnostics",
      createdAt: "Created on Monday 17 May, 2023 at 12:00 PM WAT",
    },
    {
      id: 4,
      name: "PD/06-0056",
      status: "Paid",
      department: "Therapy",
      createdAt: "Created on Monday 17 May, 2023 at 12:00 PM WAT",
    },
  ];

  return (
    <section className="w-full font-euclid-circular-a pr-12">
      <div className="flex justify-between items-center gap-8 ">
        <div className="w-[220px] h-0 border  border-stone-600 border-opacity-50" />
        <p className="text-stone-600 text-opacity-50 text-sm font-normal leading-[21px]">
          All invoices
        </p>
        <div className="w-[220px] h-0 border  border-stone-600 border-opacity-50" />
      </div>

      {/* Cards */}
      {
        savedDocs.length ?
          savedDocs.map((item) => (
            <div
              key={`${item.id}-save`}
              className="border-4 border-l-sky-500 border-t-0 border-b-0 border-r-0 pl-5 pt-3 mb-3"
            >
              <div className="flex flex-col gap-4">
                <h2 className="text-gray-600 text-lg font-semibold leading-7">
                  {item.name}
                </h2>
                <div className="flex justify-between items-center">
                  <div className="flex items-center gap-2">
                    <img src={Star} alt="star icon" />
                    <p className="text-gray-600 text-sm font-semibold leading-tight">
                      {item.status}
                    </p>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="4"
                      height="4"
                      viewBox="0 0 4 4"
                      fill="none"
                    >
                      <circle cx="2" cy="2" r="2" fill="#4B5B65" />
                    </svg>
                    <p>{item.department}</p>
                  </div>

                  <div

                    className="flex justify-center items-center gap-4 cursor-pointer"
                  >
                    <div className="flex-col" onClick={() => handleView(item)}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M21 9.00001L21 3.00001M21 3.00001H15M21 3.00001L12 12M10 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V14"
                          stroke="#4B4B4B"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <p>View</p>
                    </div>

                    <div className="flex-col" onClick={() => {
                      setcurrInvoice(item); setShowDeleteDialog(true)
                    }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="27"
                        height="26"
                        viewBox="0 0 27 26"
                        fill="none"
                      >
                        <path
                          d="M18.8333 5.8V4.84C18.8333 3.49587 18.8333 2.82381 18.5427 2.31042C18.287 1.85883 17.8791 1.49168 17.3773 1.26158C16.8069 1 16.0601 1 14.5667 1H12.4333C10.9399 1 10.1931 1 9.62269 1.26158C9.12093 1.49168 8.71298 1.85883 8.45732 2.31042C8.16667 2.82381 8.16667 3.49587 8.16667 4.84V5.8M10.8333 12.4V18.4M16.1667 12.4V18.4M1.5 5.8H25.5M22.8333 5.8V19.24C22.8333 21.2562 22.8333 22.2643 22.3974 23.0344C22.0139 23.7118 21.4019 24.2625 20.6493 24.6076C19.7936 25 18.6735 25 16.4333 25H10.5667C8.32646 25 7.20635 25 6.35071 24.6076C5.59806 24.2625 4.98613 23.7118 4.60264 23.0344C4.16667 22.2643 4.16667 21.2562 4.16667 19.24V5.8"
                          stroke="#4B4B4B"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <p>Delete</p>
                    </div>
                  </div>
                </div>
                <p>{item.createdAt}</p>
              </div>
            </div>
          ))
          :
          <p className="w-full text-center italic my-60 opacity-50">
            No Record to display
          </p>
      }
      {
        showDeleteDialog &&
        <dialog >
          <div className="w-[300px] bg-white rounded-md p-8 border">
            <p className="text-center mb-6">Are you sure you want to delete this Invoice?</p>
            <div className="flex justify-between">
              <button onClick={(e) => {
                e.preventDefault()
                handleDocDelete()
              }} className="rounded-md text-white bg-primary p-2">
                Confirm
              </button>
              <button autoFocus className="p-2 border rounded border-red-400" onClick={(e) => {
                e.preventDefault()
                setShowDeleteDialog(false)
              }}>
                Cancel
              </button>
            </div>
          </div>
        </dialog>}
      {view && <InvoiceView onClose={() => closeView()} details={currInvoice} />}
    </section>
  );
};

export default PatientBilling;
